<div class="height-32 d-flex">
  <div class="width-42 mr-sm">时间</div>
  <div>
    <span class="text-gray2" *ngIf="!checkData.date">请在下方选择</span>
    {{ checkData.date }} {{ checkData.time }}
  </div>
</div>
<div class="height-32 d-flex" style="height: auto">
  <div class="min-width-42 mr-sm">面试官</div>
  <div>
    <span class="text-gray2" *ngIf="!checkData.date">请在下方选择</span>
    <nz-tag *ngFor="let v of checkData.name; let i = index" [nzMode]="'closeable'" (nzOnClose)="handleClose(i)">
      {{ v }}
    </nz-tag>
  </div>
</div>
<div class="mt-12 time-box">
  <div class="border-1 d-flex align-items-center justify-content-between time-top pr-md pl-md" style="margin-right: 1px">
    <div>
      <div
        class="d-flex align-items-center pointer"
        nz-dropdown
        [nzDropdownMenu]="menu"
        [nzClickHide]="false"
        [(nzVisible)]="interviewerVisible"
        (nzVisibleChange)="interviewerVisibleChange()"
        nzTrigger="click"
      >
        <div class="text-xs mr-sm text-truncate" style="max-width: 90px">
          {{
            interviewerName.length == interviewerList.length
              ? '全部面试官日程'
              : interviewerName.length == 0
              ? '请选择面试官'
              : interviewerName.length + '个面试官日程'
          }}
        </div>
        <i nz-icon nzType="down"></i>
      </div>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu style="max-height: 300px; overflow-y: auto">
          <li nz-menu-item>
            <label nz-checkbox [(ngModel)]="interviewerAll" (nzCheckedChange)="interviewerAllChecked()" [nzIndeterminate]="indeterminate"
              >全部面试官日程</label
            >
          </li>
          <li nz-menu-item *ngFor="let v of interviewerList">
            <label nz-checkbox [(ngModel)]="v.checked" (nzCheckedChange)="interviewerChecked()">{{ v.name }}日程</label>
          </li>
          <li nz-menu-divider></li>
          <li nz-menu-item>
            <button nz-button nzType="link" (click)="interviewerVisibleClear()">重置</button>
            <!--            [disabled]='!(interviewerAll||indeterminate)'-->
            <button nz-button nzType="primary" (click)="interviewerVisible = false; interviewerVisibleChange()">确认</button>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <div class="d-flex align-items-center">
      <div class="icon pointer text-center"><i nz-icon nzType="left" nzTheme="outline" (click)="lClick()"></i></div>
      <div class="mr-sm ml-sm">
        {{ interviewDateArr[interviewDateIndex][0] | date: 'YYYY.MM.dd' }}~{{
          interviewDateArr[interviewDateIndex][1] | date: 'YYYY.MM.dd'
        }}
      </div>
      <div class="icon pointer text-center"><i nz-icon nzType="right" nzTheme="outline" (click)="rClick()"></i></div>
    </div>
  </div>
  <div class="grid-box">
    <div class="grid-header storeDisabled flexRow">
      <div class="time-grid text-center border-left-1 border-right-1 border-bottom-1" style="line-height: 64px">时间/日期</div>
      <ng-container *ngFor="let item of gridDay">
        <div class="flexFull day-grid border-right-1 border-bottom-1">
          <div class="text-center">{{ item.day }}</div>
          <div class="text-center">{{ item['week'] }}</div>
        </div>
      </ng-container>
    </div>
    <div class="grid-body">
      <!--      先遍历时间y轴-->
      <ng-container *ngFor="let timeItem of scheduleData; let timerIndex = index">
        <div class="time-tr flexRow">
          <div
            class="time-grid text-center border-bottom-1 border-left-1 border-right-1"
            style="width: 110px"
            [ngClass]="{ 'hover-grid': timerI == timerIndex }"
          >
            {{ timeItem['timer'] }}
          </div>
          <!--        在遍历日期 x 轴-->
          <ng-container *ngFor="let item of timeItem['lists']; let dateIndex = index">
            <div
              class="flexFull day-grid border-bottom-1 border-right-1 text-center text-white"
              [ngClass]="{
                'hover-grid': timerI == timerIndex || dateI == dateIndex,
                'hover-grid2': timerI == timerIndex && dateI == dateIndex,
                'check-grid': timeItem['timer'] == this.checkData.time && item['date'] == this.checkData.date,
                'no-select-day2':
                  (timerI == timerIndex || dateI == dateIndex) &&
                  (interviewerName.length == 0 ||
                    selectDay.indexOf(item['date']) == -1 ||
                    item['type'] == 0 ||
                    item['info'].length == undefined),
                'no-select-day':
                  interviewerName.length == 0 ||
                  selectDay.indexOf(item['date']) == -1 ||
                  item['type'] == 0 ||
                  item['info'].length == undefined
              }"
              (mouseenter)="mouseenterEvent(timerIndex, dateIndex)"
              (mouseleave)="mouseleaveEvent()"
              (click)="gridShowClick(timerIndex, dateIndex, item)"
              nz-dropdown
              [nzDropdownMenu]="grid"
              nzPlacement="bottomCenter"
              [nzClickHide]="false"
              [(nzVisible)]="item['visible']"
              nzTrigger="click"
              nz-tooltip
              [nzTooltipTitle]="'面试官：' + checkData.name"
              [nzTooltipOverlayStyle]="{
                display: timeItem['timer'] == this.checkData.time && item['date'] == this.checkData.date ? 'block' : 'none'
              }"
            >
              <!--              mousedownEvent(timerIndex, dateIndex)-->
              <ng-container *ngIf="timeItem['timer'] == this.checkData.time && item['date'] == this.checkData.date"> 约面 </ng-container>
            </div>
            <nz-dropdown-menu #grid="nzDropdownMenu">
              <ul
                style="max-height: 240px; overflow-y: auto"
                nz-menu
                *ngIf="
                  !(
                    interviewerName.length == 0 ||
                    selectDay.indexOf(item['date']) == -1 ||
                    item['type'] == 0 ||
                    item['info'].length == undefined
                  )
                "
              >
                <li nz-menu-item>请选择面试官</li>
                <li nz-menu-divider></li>
                <li nz-menu-item>
                  <label
                    nz-checkbox
                    [(ngModel)]="item.allChecked"
                    (nzCheckedChange)="interviewerTimeAllChecked(item)"
                    [nzIndeterminate]="item.indeterminate"
                    >全部</label
                  >
                </li>
                <li nz-menu-item *ngFor="let v of item.info">
                  <label nz-checkbox [(ngModel)]="v['checked']" (ngModelChange)="interviewerTimeChecked(item)">{{
                    v['interview_name']
                  }}</label>
                </li>
                <li nz-menu-divider></li>
                <li nz-menu-item>
                  <button nz-button nzType="link" (click)="reset(timeItem, item)">重置</button>
                  <button nz-button nzType="primary" (click)="ok(timeItem, item)">确认</button>
                </li>
              </ul>
            </nz-dropdown-menu>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
